<ns-grid
  [gridOptions]="gridOptions"
  [config]="gridConfig"
  [data]="data"
  [loading]="loading"
  (ready)="setUpGrid($event)"
>
  <div class="w-100 d-flex flex-column" grid-header>
    <strong>Dispute</strong>
    <div class="d-flex justify-content-between">
      <p><small>Your dispute will be automatically forwarded to your Revenue Accounting Analyst for handling.</small></p>
      <div>
        <button mat-stroked-button color="warn" (click)="navigateBack()" aria-label="cancel">Cancel</button>
        <button mat-stroked-button class="ml-2" color="warn" (click)="resetGrid()" aria-label="Clear">Clear</button>
        <button class="ml-2" mat-flat-button color="accent" [disabled]="isDisputeDisabled" (click)="disputeBills()" aria-label="dispute">Dispute
        </button>
      </div>
    </div>
  </div>
</ns-grid>
